import { cn } from "@/lib/utils";

// Cream banner with a room photo faded in from the right. Pages with a KPI row
// put it straight after with `xl:-mt-14`; `kpiOverlap` leaves room for that.
export default function PageHero({ title, subtitle, tagline, image, action, className, kpiOverlap = true }) {
  return (
    <div className={cn("relative overflow-hidden rounded-2xl bg-sidebar/60 border border-border", className)}>
      {image && (
        <div className="hidden md:block absolute inset-y-0 right-0 w-[58%]" aria-hidden="true">
          <img src={image} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[hsl(var(--sidebar))] via-[hsl(var(--sidebar)/0.55)] to-transparent" />
          {tagline && (
            <>
              <div className="hidden xl:block absolute inset-0 bg-gradient-to-bl from-black/45 via-black/10 to-transparent" />
              <p className="hidden xl:block absolute top-8 right-8 max-w-[11rem] font-serif italic text-xl leading-snug text-white drop-shadow-[0_1px_6px_rgba(0,0,0,0.45)]">
                {tagline}
              </p>
            </>
          )}
        </div>
      )}

      <div className={cn("relative px-6 sm:px-8 pt-7 sm:pt-9 pb-8 max-w-xl", kpiOverlap && "xl:pb-20")}>
        <h1 className="font-serif text-3xl sm:text-[2.6rem] leading-tight text-foreground">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
        {action && <div className="mt-5">{action}</div>}
      </div>
    </div>
  );
}
